import { render, staticRenderFns } from "./BetConsole.vue?vue&type=template&id=623b93c3"
import script from "./BetConsole.vue?vue&type=script&lang=js"
export * from "./BetConsole.vue?vue&type=script&lang=js"
import style0 from "./BetConsole.vue?vue&type=style&index=0&id=623b93c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports